import { useClassNames } from "@/utils/classNames";

import styles from "./Spinner.module.scss";
import { SpinnerProps } from "./types";

/**
 * Spinner component displays an animated circular loading indicator.
 *
 * @param className - Additional CSS class for styling
 *
 * @returns the rendered Spinner component
 *
 * @example
 * ```tsx
 * <Spinner />
 * ```
 */
const Spinner = ({ className }: SpinnerProps) => {
  const cn = useClassNames(styles, styles["spinner"], className);

  return (
    <div className={cn}>
      <svg className={styles["spinner-svg"]} viewBox="25 25 50 50">
        <circle className={styles["spinner-circle"]} cx="50" cy="50" r="20" />
      </svg>
    </div>
  );
};

export { Spinner };
